import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";

const OVERVIEW = [
    "Website monitoring and maintenance keeps your online business running: it confirms your site is up, working correctly and up to date, and it surfaces the critical data needed to keep it that way.",
];

const FEATURES = [
    { title: "Website monitoring", text: "Monitoring is the process of watching your web service and website — tracking critical performance and security functions. Our service runs regular website audits, checks built-in security and applies the latest updates. Our experienced, professional team covers every aspect necessary for effective website monitoring." },
    { title: "Website maintenance", text: "Maintaining a website is essential for online businesses — neglect it and you can lose opportunities that would have converted into leads and sales. We identify every opportunity and perform the actions needed to collect critical website data, so your site keeps working with the proper functions and stays up to date." },
    { title: "Why it matters", text: "If your website is slow to load or throws errors, users may not return. That makes monitoring & maintenance a crucial aspect of any online business today — avoid the lost revenue and profit that downtime and other critical issues cause with 24×7 website monitoring & maintenance." },
];

export default function WebsiteMonitoringAndMaintenance() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Website Monitoring & Maintenance" eyebrowAs="span">
                    Get notified the moment your site is up, working and usable as expected — we detect and resolve website performance issues proactively.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
